module.exports = __webpack_public_path__ + "img/q_qs73-038-1991.prt.445b8853.jpg";